import { Button } from "../components/Button";
import { Dialog, DialogClose, DialogContent } from "../components/Dialog";
import { ImageWrapper } from "../components/ImageWrapper";
import { Spinner } from "../components/Spinner";
import { ChevronLeft, ChevronRight, Download01, XClose, } from "../icons/v2-stroke";
import { cn } from "../lib/utils";
import React, { useCallback, useState } from "react";
function downloadFile(url, filename) {
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
function ImageZoomDialog({ open, onOpenChange, image, navigation, }) {
    var _a;
    const [imageLoaded, setImageLoaded] = useState(false);
    const handleDownload = useCallback((e) => {
        e.stopPropagation();
        if (image.downloadUrl && image.title) {
            downloadFile(image.downloadUrl, image.title);
        }
    }, [image.downloadUrl, image.title]);
    // biome-ignore lint/correctness/useExhaustiveDependencies: open and image.src are props that should trigger the reset
    React.useEffect(() => {
        setImageLoaded(false);
    }, [open, image.src]);
    return (React.createElement(Dialog, { open: open, onOpenChange: onOpenChange },
        React.createElement(DialogContent, { size: "fit", className: "overflow-hidden p-3 w-fit" },
            React.createElement("div", { className: "relative flex items-center justify-center gap-2" },
                (navigation === null || navigation === void 0 ? void 0 : navigation.hasPrevious) && (React.createElement(Button, { variant: "ghost", size: "sm", icon: ChevronLeft, onClick: (e) => {
                        e.stopPropagation();
                        navigation.onPrevious();
                    } })),
                React.createElement("div", { className: "relative rounded overflow-hidden" }, image.isLoading ? (React.createElement("div", { className: cn("mx-auto flex aspect-square w-full min-w-[50vh]", "max-w-[80vh] items-center justify-center", "bg-muted-background") },
                    React.createElement(Spinner, { variant: "dark", size: "lg" }))) : (React.createElement(React.Fragment, null,
                    React.createElement(ImageWrapper, { src: image.src, alt: (_a = image.alt) !== null && _a !== void 0 ? _a : "", className: "max-h-[calc(90vh-1.5rem)] max-w-[calc(90vw-1.5rem)]", onLoad: () => setImageLoaded(true) }),
                    React.createElement(DialogClose, { asChild: true },
                        React.createElement(Button, { variant: "outline", size: "xs", icon: XClose, className: "absolute right-2 top-2" })),
                    imageLoaded && image.downloadUrl && (React.createElement(Button, { variant: "outline", size: "xs", icon: Download01, tooltip: "Download", className: "absolute bottom-2 right-2", onClick: handleDownload }))))),
                (navigation === null || navigation === void 0 ? void 0 : navigation.hasNext) && (React.createElement(Button, { variant: "ghost", size: "sm", icon: ChevronRight, onClick: (e) => {
                        e.stopPropagation();
                        navigation.onNext();
                    } }))))));
}
ImageZoomDialog.displayName = "ImageZoomDialog";
export { downloadFile, ImageZoomDialog };
//# sourceMappingURL=ImageZoomDialog.js.map